import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGripDotsVertical } from '@fortawesome/pro-solid-svg-icons/faGripDotsVertical';
import React, { useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Button } from 'ui-components/components/button';
import { AllocationRulesContext } from './context';
import { EDITOR_TYPE_CUSTOM } from './rule-helper';
import CustomEditor from './rule-editors/custom-editor';
import SingleSelectionEditor from './rule-editors/single-selection-editor';
import RulePrioritizationDropdown from './rule-priorotozation-dropdown/';
import messages from './messages';
import classnames from 'classnames';
import style from './style.module.less';

const EditableRuleBody = ({ dragProvided, allocationRuleId }) => {
  const { allocationRules, setRuleIdInEdit, setAllocationRules, onUpdateRuleName, saveFilterAndRule } = useContext(AllocationRulesContext);
  const rule = allocationRules.find((r) => r.allocationRuleId === allocationRuleId);
  const onRuleNameUpdated = useCallback(
    (newRuleName) => {
      if (!rule) {
        return;
      }
      onUpdateRuleName({
        ...rule,
        name: newRuleName,
      });
    },
    [onUpdateRuleName, rule],
  );
  const onRuleEditorClosed = useCallback(() => {
    setRuleIdInEdit(undefined);
  }, [setRuleIdInEdit]);

  const editor =
    rule?.editorType === EDITOR_TYPE_CUSTOM ? (
      <CustomEditor
        filterId={rule.filterId}
        onRuleEditorClosed={onRuleEditorClosed}
        onRuleNameUpdated={onRuleNameUpdated}
        ruleName={rule?.name}
      />
    ) : (
      <SingleSelectionEditor rule={rule} />
    );
  const onCancelEdit = useCallback(() => {
    setRuleIdInEdit(undefined);
    setAllocationRules(allocationRules.filter((r) => r.allocationRuleId > 0));
  }, [setRuleIdInEdit, allocationRules, setAllocationRules]);

  const saveRules = useCallback(() => {
    saveFilterAndRule(rule);
  }, [saveFilterAndRule, rule]);

  return (
    <div className={classnames(style['head-or-item'], style.item)}>
      <div className={style.task}>
        <div className={style['rule-grabber']} {...dragProvided.dragHandleProps}>
          <FontAwesomeIcon icon={faGripDotsVertical} />
        </div>
        <div>{editor}</div>
      </div>
      <div className={style.prioritize}>
        <RulePrioritizationDropdown allocationRuleId={allocationRuleId} />
      </div>
      <div className={style['rule-actions']}>
        <div>
          <Button onClick={saveRules} theme='link'>
            <FormattedMessage {...messages.allocationStrategiesSave} />
          </Button>
        </div>
        <div>
          <Button onClick={onCancelEdit} theme='link'>
            <FormattedMessage {...messages.allocationStrategiesCancel} />
          </Button>
        </div>
      </div>
    </div>
  );
};

EditableRuleBody.propTypes = {
  dragProvided: PropTypes.object.isRequired,
  allocationRuleId: PropTypes.string.isRequired,
};

export default EditableRuleBody;
